<template>
  <Pagination class="scroll-animate fadeInUp" data-vp-add-class="visible-animation" 
    :value="page" 
    :pageCount="pageCount"
    :url-factory="getUrl"
    @input="onInput"/>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Pagination from "../Pagination.vue";

export default {
  components: {
    Pagination
  },
  computed: {
    ...mapState(["pageCount"]),
    ...mapGetters(["page", "areaUrlCode"])
  },
  mounted() {
    this.$nextTick(() => viewportCheck($(this.$el)));
  },
  methods: {
    onInput(page) {
      if(page === 1) page = undefined;
      const areaUrlCode = this.areaUrlCode;
      if (areaUrlCode) {
        this.$router.replace({
          name: 'publicationsWithArea',
          params: {areaUrlCode, page},
        });
      }
      else {
        this.$router.replace({
          name: 'publications',
          params: {page: page},
        });
      }
    },
    getUrl(page) {
      if (page === 1) page = undefined;
      const areaUrlCode = this.areaUrlCode;
      if (areaUrlCode) {
        return this.$router.resolve({
          name: 'publicationsWithArea',
          params: {areaUrlCode, page},
        }).href;
      }
      return this.$router.resolve({
        name: 'publications',
        params: {page: page},
      }).href;
    }
  }
};
</script>
